import { defineMessages } from 'react-intl';

const translations = {
  properties: {
    shippingNumber: {
      id: 'properties.shippingNumber',
      defaultMessage: 'Shipping number',
      description: 'title of the property shipping number',
    },
    shippingMethod: {
      id: 'properties.shippingMethod',
      defaultMessage: 'Shipping method',
      description: 'title of the property shipping method',
    },
    expectedAt: {
      id: 'properties.expectedAt',
      defaultMessage: 'Expected at',
      description: 'title of the property expected at',
    },
    shipAt: {
      id: 'properties.shipAt',
      defaultMessage: 'Ship at',
      description: 'title of the property ship at',
    },
    parcelCount: {
      id: 'properties.parcelCount',
      defaultMessage: 'Parcel count',
      description: 'title of the property parcel count',
    },
    parcelNumber: {
      id: 'properties.parcelNumber',
      defaultMessage: 'Parcel number',
      description: 'title of the property parcel number',
    },
    itemCount: {
      id: 'properties.itemCount',
      defaultMessage: 'Item count',
      description: 'title of the property item count',
    },
    toAddress: {
      id: 'properties.toAddress',
      defaultMessage: 'To',
      description: 'title of the property to address',
    },
  },
};

export default defineMessages(translations);
